<template>
  <transition name="loading-fade">
    <div v-if="$store.getters.loadingVisible" class="loading-overlay">
      <div class="loading-container">
        <!-- Logo 区域 -->
        <div class="logo-container">
          <img src="../assets/logo.png" alt="Logo" class="loading-logo" />
        </div>
        <!-- 自定义文本 -->
        <div class="loading-text">
          {{ $store.getters.loadingText }}
        </div>
         <!-- 加载动画 -->
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
        <!-- 可选的副文本 -->
        <div v-if="$store.getters.loadingSubText" class="loading-sub-text">
          {{ $store.getters.loadingSubText }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  watch: {
    '$store.getters.loadingVisible': {
      handler(newVal) {
        if (newVal) {
          // 显示加载框时禁止页面滚动
          document.body.style.overflow = 'hidden'
        } else {
          // 隐藏加载框时恢复页面滚动
          document.body.style.overflow = ''
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    // 组件销毁前确保恢复页面滚动
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-container {
  text-align: center;
  color: white;
}

.logo-container {
  margin-bottom: 20px;
}

.loading-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  animation: logo-pulse 2s ease-in-out infinite;
}

.spinner-container {
  margin: 20px 0;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.loading-text {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #fff;
}

.loading-sub-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

/* 动画效果 */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes logo-pulse {
  0%, 100% { 
    transform: scale(1);
    opacity: 1;
  }
  50% { 
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* 淡入淡出过渡效果 */
.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.3s ease;
}

.loading-fade-enter,
.loading-fade-leave-to {
  opacity: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .loading-logo {
    width: 60px;
    height: 60px;
  }
  
  .spinner {
    width: 40px;
    height: 40px;
  }
  
  .loading-text {
    font-size: 16px;
  }
  
  .loading-sub-text {
    font-size: 12px;
  }
}
</style> 